export default __webpack_public_path__ + "media/src/assets/images/creative-7fc533fecd98986ceafef16e4f168e8b.png";